import debounce from "lodash.debounce";
import CurrentPlayer from "./CurrentPlayer";
import { PlayerId } from "../Auth";
import GraphQLSDK from "../GraphQLSDK";
import { serverPositionToVector3, serverRotationToEuler } from "../Tools";
import { REFRESH_TICK } from "../Constants";

class CurrentPlayerOnline {
    public currentPlayer: CurrentPlayer;

    public currentPlayerId: PlayerId;

    public currentPlayerName: string;

    constructor(
        currentPlayer: CurrentPlayer,
        currentPlayerId: PlayerId,
        currentPlayerName: string
    ) {
        this.currentPlayer = currentPlayer;
        this.currentPlayerId = currentPlayerId;
        this.currentPlayerName = currentPlayerName;

        this.load();
    }

    private async load(): Promise<void> {
        const playerData = await GraphQLSDK.getPlayer({
            id: this.currentPlayerId,
        });

        if (playerData.onlineObjects.length === 0) {
            // Spawn code
            // TODO spawn player near own flag.
            this.currentPlayer.position.x = (Math.random() - 0.5) * 100;
            this.currentPlayer.position.z = (Math.random() - 0.5) * 100;
        }

        this.currentPlayer.position = serverPositionToVector3(
            playerData.onlineObjects[0].position
        );

        this.currentPlayer.rotation = serverRotationToEuler(
            playerData.onlineObjects[0].rotation
        );

        this.currentPlayer.camera.position.set(
            this.currentPlayer.position.x,
            this.currentPlayer.position.y,
            this.currentPlayer.position.z
        );

        this.currentPlayer.camera.rotation.set(
            this.currentPlayer.rotation.x,
            this.currentPlayer.rotation.y,
            this.currentPlayer.rotation.z
        );

        this.currentPlayer.team =
            (playerData.onlineObjects[0].team as
                | "RED"
                | "BLUE"
                | undefined
                | null) || null;
    }

    public save(): void {
        GraphQLSDK.mutateCurrentPlayer({
            id: this.currentPlayerId,
            position: this.currentPlayer.position,
            rotation: {
                x: this.currentPlayer.rotation.x,
                y: this.currentPlayer.rotation.y,
                z: this.currentPlayer.rotation.z,
            },
            name: this.currentPlayerName,
        });
    }

    public debouncedSave = debounce(this.save, REFRESH_TICK, {
        maxWait: REFRESH_TICK,
    });

    public update(): void {
        this.debouncedSave();
    }
}

export default CurrentPlayerOnline;
